import { Component, type ReactNode } from 'react';

// Catches a part of the page that failed to load (for example an old file after
// a deploy), so the rest keeps working and only this part shows a note.
export default class ChunkBoundary extends Component<{ fallback: ReactNode; children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: unknown) { console.error('[Zuzu] part of the page failed to load', error); }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}
